<div class="shop-card-skeleton">
  <div class="skeleton-banner shimmer"></div>
  <div class="skeleton-logo shimmer"></div>
  <div class="skeleton-body">
    <div class="skeleton-line shimmer wide"></div>
    <div class="skeleton-line shimmer narrow"></div>
    <div class="skeleton-line shimmer medium"></div>
  </div>
  <div class="skeleton-actions">
    <div class="skeleton-btn shimmer"></div>
    <div class="skeleton-btn shimmer"></div>
  </div>
</div>
